import { Pipe, PipeTransform } from '@angular/core';
import { isSameDay, isSameYear } from 'date-fns';

import { QPointDateFormatService } from '../services/date-format.service';
import { QPointDateFormat } from '../services/DateFormat';

@Pipe({
  name: 'qPointDateFormat',
  standalone: true,
  pure: false
})
export class QPointDateFormatPipe implements PipeTransform {
  constructor(private dateFormatService: QPointDateFormatService) {}

  transform(date: any, customFormat?: string, customCulture?: string, inTimezone?: string): string {
    if (date === null || date === undefined) {
      return '';
    }

    if (customFormat == null) {
      return this.dateFormatService.formatToCustomDateFormat(
        date,
        QPointDateFormat.ShortDateTime,
        customCulture,
        inTimezone
      );
    }

    if(customFormat === QPointDateFormat.DateIntervalShort && date.start && date.end) {
      if(isSameDay(date.start, date.end)) {
        return `${this.dateFormatService.formatToCustomDateFormat(date.end, QPointDateFormat.DateIntervalShort, customCulture)}`
      } else if(isSameYear(date.start, date.end)) {
        return `${this.dateFormatService.formatToCustomDateFormat(date.start, QPointDateFormat.DateIntervalShort, customCulture).replace(date.start.getFullYear().toString(), '')} - ${this.dateFormatService.formatToCustomDateFormat(date.end, QPointDateFormat.DateIntervalShort, customCulture)}`
      } else {
        return `${this.dateFormatService.formatToCustomDateFormat(date.start, QPointDateFormat.DateIntervalShort, customCulture)} - ${this.dateFormatService.formatToCustomDateFormat(date.end, QPointDateFormat.DateIntervalShort, customCulture)}`
      }
    }

    return this.dateFormatService.formatToCustomDateFormat(date, customFormat, customCulture, inTimezone);
  }
}
